import { render } from "./TabelaSubmenu.vue?vue&type=template&id=29dcf0ab&scoped=true"
import script from "./TabelaSubmenu.vue?vue&type=script&lang=js"
export * from "./TabelaSubmenu.vue?vue&type=script&lang=js"

import "./TabelaSubmenu.vue?vue&type=style&index=0&id=29dcf0ab&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29dcf0ab"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QLinearProgress,QTable,QTr,QTh,QTd,QIcon,QBtn,QPagination});
